import { ca } from '@cian/analytics';
import { createConsumer, createSubscriber, getGlobalEventsLogs, IConsumer, IEvent } from '@cian/events-log';

import { selectTrackingUser } from '../../selectors';
import { updateUserData } from '../../store/user';
import { prepareEbcAction } from '../analytics';

import type { IThunkActionCreator } from '../../store';
import type { RootAction } from '../../types/redux/RootAction';

export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

interface IViewData {
  headingType: string | undefined;
}

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
  viewData?: IViewData;
  onSuccess?(): IThunkActionCreator | RootAction;
  onCloseNoAuth?(): IThunkActionCreator | RootAction;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): IThunkActionCreator {
  return (dispatch, getState) => {
    if (typeof window !== 'undefined') {
      const globalLog = getGlobalEventsLogs();
      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          await dispatch(updateUserData());

          dispatch(prepareEbcAction());
          const trackingUser = selectTrackingUser(getState());
          ca('user', trackingUser);

          if (window.__reloadHeader__) {
            window.__reloadHeader__();
          }

          if (parameters && parameters.onSuccess) {
            dispatch(parameters.onSuccess());
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          if (parameters && parameters.onCloseNoAuth) {
            dispatch(parameters.onCloseNoAuth());
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);

      globalLog.produce(TOPIC_USER, {
        type: 'authenticate',
        value: {
          autoRefresh: false,
          viewData: parameters?.viewData || {},
        },
      });
    }
  };
}
